module.exports = "<div >\n    <div class=\"{{styles.toastContainer}}\" >{{toastTip}}</div>\n</div>\n";